/* =========================================================
   PhotoSwipe custom SVG icons
   ========================================================= */

const STROKE = 1.0;

const PSWP_CLOSE_SVG = `
<svg viewBox="0 0 24 24" aria-hidden="true">
  <line x1="6.5" y1="6.5" x2="17.5" y2="17.5"
    stroke="currentColor" stroke-width="${STROKE}" stroke-linecap="round"/>
  <line x1="17.5" y1="6.5" x2="6.5" y2="17.5"
    stroke="currentColor" stroke-width="${STROKE}" stroke-linecap="round"/>
</svg>
`;

// Safe to keep (we hide default zoom button in CSS)
const PSWP_ZOOM_IN_SVG = `
<svg viewBox="0 0 24 24" aria-hidden="true">
  <circle cx="12" cy="12" r="10"
    fill="none" stroke="currentColor" stroke-width="${STROKE}"/>
  <line x1="12" y1="7" x2="12" y2="17"
    stroke="currentColor" stroke-width="${STROKE}" stroke-linecap="round"/>
  <line x1="7" y1="12" x2="17" y2="12"
    stroke="currentColor" stroke-width="${STROKE}" stroke-linecap="round"/>
</svg>
`;

const PSWP_ZOOM_OUT_SVG = `
<svg viewBox="0 0 24 24" aria-hidden="true">
  <circle cx="12" cy="12" r="10"
    fill="none" stroke="currentColor" stroke-width="${STROKE}"/>
  <line x1="7" y1="12" x2="17" y2="12"
    stroke="currentColor" stroke-width="${STROKE}" stroke-linecap="round"/>
</svg>
`;

document.addEventListener('DOMContentLoaded', () => {
  const isDesktop = window.matchMedia('(min-width: 990px)').matches;
  const root = isDesktop
    ? document.querySelector('.s-main-product__gallery--desktop')
    : document.querySelector('.s-main-product__gallery--mobile');

  if (!root) return;

  const allLinks = Array.from(root.querySelectorAll('.js-pswp-item'));
  if (!allLinks.length) return;

  // Visible = takes layout (display:none => not visible)
  const getVisibleLinks = () => allLinks.filter(a => a.getClientRects().length > 0);

  const buildItemsFromLinks = (links) => {
    return links.map((a) => {
      const img = a.querySelector('img');
      return {
        src: a.dataset.pswpSrc,
        width: parseInt(a.dataset.pswpWidth, 10),
        height: parseInt(a.dataset.pswpHeight, 10),
        msrc: img ? (img.currentSrc || img.src) : undefined
      };
    }).filter(it => it.src && it.width && it.height);
  };

  const lightbox = new PhotoSwipeLightbox({
    dataSource: [],
    pswpModule: PhotoSwipe,
    bgOpacity: 1,
    wheelToZoom: true,
    clickToCloseNonZoomable: true,

    // Prevent PSWP from doing its own “tap zoom” (keeps behavior consistent)
    tapAction: 'toggleControls',
    imageClickAction: 'none',
    doubleTapAction: false,

    closeSVG: PSWP_CLOSE_SVG,
    zoomSVG: PSWP_ZOOM_IN_SVG,
    zoomOutSVG: PSWP_ZOOM_OUT_SVG
  });

  lightbox.on('uiRegister', () => {

    /* =========================================================
       Zoom In / Zoom Out as REAL PhotoSwipe buttons (clickable)
       ========================================================= */

    const getCenter = (pswp) => ({
      x: pswp.viewportSize.x / 2,
      y: pswp.viewportSize.y / 2
    });

    const getLevels = (slide) => {
      const zl = slide.zoomLevels || {};
      const initial = zl.initial ?? slide.minZoomLevel ?? 1;
      const max = zl.max ?? slide.maxZoomLevel ?? initial;
      const secondary = zl.secondary ?? Math.min(initial * 1.6, max);
      return { initial, secondary, max };
    };

    const zoomTo = (pswp, level) => {
      const slide = pswp.currSlide;
      if (!slide) return;

      // Use slide.zoomTo (stable, prevents jump/disappear)
      slide.zoomTo(level, getCenter(pswp), 260);

      // Recenter when fully zoomed out
      const { initial } = getLevels(slide);
      if (Math.abs(level - initial) < 0.002) {
        slide.panTo(0, 0);
      }
    };

    // Zoom IN button
    lightbox.pswp.ui.registerElement({
      name: 'zoomIn',
      title: 'Zoom in',
      order: 7,
      isButton: true,
      appendTo: 'bar', // IMPORTANT: clickable UI layer
      html: '<span class="pswp__zoom-glyph" aria-hidden="true">+</span>',
      onClick: (e, el, pswp) => {
          e.preventDefault();
          e.stopPropagation();

          const slide = pswp.currSlide;
          if (!slide) return;

          const zl = slide.zoomLevels || {};
          const initial = zl.initial ?? slide.minZoomLevel ?? 1;
          const secondary = zl.secondary ?? (initial * 1.25);
          const max = zl.max ?? slide.maxZoomLevel ?? (secondary * 1.25);

          const cur = slide.currZoomLevel ?? initial;

          // Progressive: move toward secondary, then toward max
          let next;
          if (cur < secondary - 0.01) next = cur * 1.12;
          else next = cur * 1.12;

          // Clamp, but ensure it ALWAYS increases at least a tiny bit (or jump to secondary/max)
          next = Math.min(next, max);
          if (next <= cur + 0.001) {
            next = (cur < secondary - 0.01) ? secondary : max;
          }

          slide.zoomTo(next, { x: pswp.viewportSize.x / 2, y: pswp.viewportSize.y / 2 }, 380);
        }
    });

    // Zoom OUT button
    lightbox.pswp.ui.registerElement({
      name: 'zoomOut',
      title: 'Zoom out',
      order: 8,
      isButton: true,
      appendTo: 'bar', // IMPORTANT: clickable UI layer
      html: '<span class="pswp__zoom-glyph" aria-hidden="true">−</span>',
          onClick: (e, el, pswp) => {
        e.preventDefault();
        e.stopPropagation();

        const slide = pswp.currSlide;
        if (!slide) return;

        const zl = slide.zoomLevels || {};
        const initial = zl.initial ?? slide.minZoomLevel ?? 1;
        const cur = slide.currZoomLevel ?? initial;

        let next = cur / 1.12;
        if (next < initial) next = initial;

        slide.zoomTo(next, { x: pswp.viewportSize.x / 2, y: pswp.viewportSize.y / 2 }, 380);

        if (Math.abs(next - initial) < 0.002) {
          slide.panTo(0, 0);
        }
      }
    });

    /* =========================================================
       Thumbnail bar UI
       ========================================================= */
    lightbox.pswp.ui.registerElement({
      name: 'thumbs',
      order: 9,
      isButton: false,
      appendTo: 'root',
      html: '<div class="pswp__thumbs" aria-label="Gallery thumbnails"></div>',
      onInit: (el, pswp) => {
        const thumbsEl = el;

        const render = () => {
          thumbsEl.innerHTML = '';
          const count = pswp.getNumItems();

          for (let i = 0; i < count; i++) {
            const item = pswp.getItemData(i);
            const thumbSrc = item.msrc || item.src;

            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'pswp__thumb';
            btn.dataset.index = String(i);
            btn.setAttribute('aria-label', `Go to image ${i + 1}`);
            btn.innerHTML = `<img src="${thumbSrc}" alt="" loading="lazy">`;

            btn.addEventListener('click', (ev) => {
              ev.preventDefault();
              ev.stopPropagation();
              pswp.goTo(i);
            });

            thumbsEl.appendChild(btn);
          }
        };

        const setActive = () => {
          thumbsEl.querySelectorAll('.pswp__thumb').forEach(b => b.classList.remove('is-active'));
          const active = thumbsEl.querySelector(`.pswp__thumb[data-index="${pswp.currIndex}"]`);
          if (active) {
            active.classList.add('is-active');
            active.scrollIntoView({ block: 'nearest', inline: 'center' });
          }
        };

        pswp.on('afterInit', () => {
          pswp.element.classList.add('pswp--thumbs-left'); // desktop CSS
          render();
          setActive();
        });

        pswp.on('change', setActive);
      }
    });
  });

  // Click -> build gallery from currently visible items (variant-safe)
  allLinks.forEach((a) => {
    a.addEventListener('click', (e) => {
      e.preventDefault();

      const visibleLinks = getVisibleLinks();
      const items = buildItemsFromLinks(visibleLinks);
      if (!items.length) return;

      const index = visibleLinks.indexOf(a);
      lightbox.options.dataSource = items;
      lightbox.loadAndOpen(index >= 0 ? index : 0);
    });
  });

  lightbox.init();
});
